import { FormlyFieldConfig } from 'ng-formly';
export const chartFields: Array<FormlyFieldConfig> = [
    {
        type: 'input-field',
        key: 'name',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            label: 'Chart Name',
            required: true,
        },
    },
    {
        type: 'input-field',
        key: 'label',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            label: 'Chart Widget Label',
            required: true,
        },
    },
    {
        key: 'height',
        type: 'input-field',
        className: 'col-md-2',
        defaultValue: 250,
        templateOptions: {
            type: 'text',
            label: 'Height in px',
            required: true
        }
    },
    {
        key: 'width',
        type: 'input-field',
        className: 'col-md-2',
        defaultValue: 100,
        templateOptions: {
            type: 'percent',
            label: 'Width in %',
            required: true
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-6',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Description',
            rows: 20
        }
    },
    {
        key: 'options',
        type: 'textarea-field',
        className: 'col-md-6',
        templateOptions: {
            label: 'Chart Options JSON',
            required: true,
            description: 'Chart Options',
            rows: 20
        }
    },
    {
        key: 'developmentpriority',
        type: 'input-field',
        className: 'col-md-3',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Development Priority'
        }
    },
    {
        key: 'developmentstatus',
        type: 'select-component',
        className: 'col-md-3',
        defaultValue: 'Yet to Start',
        templateOptions: {
            options: [{
                label: 'Yet to Start',
                value: 'Yet to Start'
            }, {
                label: 'Work in Progress',
                value: 'Work in Progress'
            }, {
                label: 'Completed',
                value: 'Completed'
            }, {
                label: 'Approved',
                value: 'Approved'
            }],
            label: 'Development Status',
            required: true,
            placeholder: ''
        }
    },
    {
        key: 'developmentnotes',
        type: 'input-field',
        className: 'col-md-6',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: false,
            label: 'Development Team Notes'
        }
    }

    // {
    //     key: 'dataelement',
    //     type: 'select-component',
    //     className: 'col-md-4',
    //     templateOptions: {
    //         type: 'dataelement',
    //         label: 'DataElement',
    //         required: false,
    //         description: 'Enter ObjectId'
    //     }
    // },

];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/chart.ts